// extracted by mini-css-extract-plugin
export default {"dialog":"Ohb1kavJ5oc5N1YerAiwTVhzq234kMyzsz2NsG2T3k8="};